/* A Leading Role - welcome pop-up additions: account link + Front Row.
 *
 * Additive on purpose: sections/alr-footer.liquid owns #modal-welcome and is
 * edited by other work, so this appends rather than rewriting that file.
 * Built with DOM calls rather than innerHTML so nothing here can be injected.
 *
 * Order inside .w-body: sign-up form, account line, Front Row, dismiss.
 * Email capture stays the primary action. The store runs new customer
 * accounts, so an account cannot be created from this form - Shopify emails a
 * code from its own page - hence a link rather than a second field.
 *
 * Gold is decorative only: on the cream #F6EBD2 ground it fails contrast as
 * text, so anything readable is maroon or the existing muted brown.
 */
(function () {
  var JOIN = '/products/front-row-membership';
  var MAROON = '#5B1220';
  var GOLD = '#C9A227';
  var MUTED = '#5A452F';

  function loginUrl() {
    try {
      var el = document.getElementById('c-customer-data');
      var data = JSON.parse(el.textContent);
      if (data && data.logged_in) return null; // already signed in
      if (data && data.login_url) return data.login_url;
    } catch (err) {}
    return '/account/login';
  }

  function styles() {
    if (document.getElementById('w-fr-style')) return;
    var s = document.createElement('style');
    s.id = 'w-fr-style';
    s.textContent = [
      '.w-acct{margin:14px 0 0;font-size:12.5px;line-height:1.55;color:' + MUTED + ';text-align:center}',
      '.w-acct a{color:' + MAROON + ';text-decoration:underline;text-underline-offset:2px}',
      '.w-fr{margin-top:20px;text-align:center}',
      '.w-fr-rule{display:flex;align-items:center;justify-content:center;gap:10px;margin-bottom:14px}',
      '.w-fr-rule i{height:1px;width:52px;background:' + GOLD + ';opacity:.7;display:block}',
      '.w-fr-rule b{color:' + GOLD + ';font-size:12px;font-weight:400}',
      '.w-fr-name{font-family:"Playfair Display",Georgia,serif;font-size:19px;letter-spacing:.14em;color:' + MAROON + ';margin:0 0 7px}',
      '.w-fr-line{margin:0 0 14px;font-size:13.5px;line-height:1.55;color:' + MUTED + '}',
      '.w-fr-link{display:inline-block;font-size:11.5px;letter-spacing:.13em;text-transform:uppercase;text-decoration:none;',
      'border:1px solid ' + MAROON + ';color:' + MAROON + ';padding:11px 22px;border-radius:3px;transition:.16s}',
      '.w-fr-link:hover{background:' + MAROON + ';color:#FBF7F0}',
      '@media (max-width:420px){.w-fr-line{font-size:13px}}'
    ].join('');
    document.head.appendChild(s);
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }

  function accountLine() {
    var url = loginUrl();
    if (!url) return null;
    var p = el('p', 'w-acct');
    p.appendChild(document.createTextNode('No password needed — '));
    var a = el('a', null, 'sign in');
    a.setAttribute('href', url);
    // Sign in without leaving the page. alr.js already owns this: its
    // delegated [data-modal] click handler calls preventDefault and then
    // openAccountPopup(CUSTOMER_DATA.login_url), the same popup the header
    // account icon uses. The href stays put as the fallback for middle-click,
    // for "open in new tab", and for anyone with JS off.
    a.setAttribute('data-modal', 'account');
    p.appendChild(a);
    p.appendChild(document.createTextNode(
      ' any time with this email to track orders, save favorites and get more from the Concierge.'
    ));
    return p;
  }

  function frontRow() {
    var wrap = el('div', 'w-fr');

    var rule = el('div', 'w-fr-rule');
    rule.appendChild(el('i'));
    var star = el('b');
    star.innerHTML = '&#10022;';
    rule.appendChild(star);
    rule.appendChild(el('i'));
    wrap.appendChild(rule);

    wrap.appendChild(el('div', 'w-fr-name', 'FRONT ROW'));
    wrap.appendChild(el(
      'p',
      'w-fr-line',
      'Our membership, $99 a year. Free shipping on every order, free returns for 60 days, 10 points for every $1, and every drop 48 hours early.'
    ));

    var link = el('a', 'w-fr-link', 'See Front Row');
    link.setAttribute('href', JOIN);
    wrap.appendChild(link);
    return wrap;
  }

  function build() {
    var modal = document.getElementById('modal-welcome');
    if (!modal || modal.querySelector('.w-fr')) return;
    var body = modal.querySelector('.w-body');
    if (!body) return;

    styles();

    // Anchor everything above the dismiss control so it stays last.
    var skip = body.querySelector('#w-skip');
    var acct = accountLine();
    if (acct) {
      if (skip) body.insertBefore(acct, skip);
      else body.appendChild(acct);
    }
    var fr = frontRow();
    if (skip) body.insertBefore(fr, skip);
    else body.appendChild(fr);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
